// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://apisdev.onecalltms.com/',
  reportServerUrl:'https://apisdev.onecalltms.com/',
  CORPORATE_PANEL_URL: "https://fundingsourcedev.onecalltms.com/",
  TRACKING_URL: "https://membercare.nemtbusiness.com/trip-tracking/",
  BROKER_PANEL_URL: 'https://brokerdevapi.onecalltms.com/',
  BROKER_HMAC_SECRET: 'ntF2EnIzvPfPdfM82Uq9FB0uLcwJfSlD234d'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
